export default __webpack_public_path__ + "static/media/hour-clock.d3fc26d9.svg";